import { Container, Row } from "react-bootstrap";

export function PreviousTeams({ teams }) {
  // Group teams by year
  const teamsByYear = teams.reduce((acc, cur) => {
    const key = cur.year;
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(cur);
    return acc;
  }, {});

  // Sort years decreasing
  const sortedTeamsByYear = Object.keys(teamsByYear)
    .sort((a, b) => Number(b) - Number(a));

  return (
    <Container>
      {sortedTeamsByYear.map((year) => (
        <div key={year}>
          <h3 className="team-year"><b>{year}</b></h3>
          <hr />
          {teamsByYear[year].map((team, index) => (
            <div key={index}>
                <h4 style={{ marginTop: "20px" }}><b>{team.name}</b></h4>
                <Container className="members-container">
                  <h5>Supervisors:</h5>
                  <Container style={{ marginLeft: "30px" }}>
                    <Row xs={2} md={3} lg={5}>
                      {team.supervisors.map((supervisor, index) => (
                        <p key={index}>{supervisor}</p>
                      ))}
                    </Row>
                  </Container>
                  <h5>Team Members:</h5>
                  <Container style={{ marginLeft: "30px" }}>
                    <Row xs={2} md={3} lg={5}>
                      {team.team_members.map((team_member, index) => (
                        <p key={index}>{team_member}</p>
                      ))}
                    </Row>
                  </Container>
                  <h5>Results:</h5>
                  <Container style={{ marginLeft: "30px" }}>{team.results}</Container>
                </Container>
            </div>
          ))}
        </div>
      ))}
    </Container>
  );
}
